/**
 * @generated SignedSource<<13d1d09cfd86d1b969169fbbe4e3156e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment$data = {
  readonly enableSolutionReveal: boolean;
  readonly id: string;
  readonly solutionText: string | null;
  readonly text: string;
  readonly title: string;
  readonly " $fragmentType": "freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment";
};
export type freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment$key = {
  readonly " $data"?: freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableSolutionReveal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "solutionText",
      "storageKey": null
    }
  ],
  "type": "FreeTextSelfCheckElement",
  "abstractKey": null
};

(node as any).hash = "880c636bae6224b7549778b7587fdea7";

export default node;
